import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { PlatformService } from '../../../core/services/platform.service';
import { WindowControlsComponent } from '../window-controls/window-controls.component';

/**
 * Draggable strip pinned to the top of the window for Electron screens that render outside the main
 * shell (login, registration, password reset, legal pages, etc.) and therefore have no
 * `app-title-bar`.
 *
 * Both desktop platforms hide the native caption, so without this the top edge of those screens is
 * dead: on macOS (`titleBarStyle: 'hiddenInset'`) the window cannot be moved or double-click-zoomed,
 * and on Windows (`titleBarStyle: 'hidden'`) there is not even a close button — the app would be
 * unquittable from its own login screen. So the strip is invisible on macOS, where the system still
 * draws the traffic lights over it, and carries our own caption buttons on Windows.
 */
@Component({
  selector: 'app-window-drag-region',
  imports: [WindowControlsComponent],
  template: '@if (showWindowControls) { <app-window-controls /> }',
  styleUrl: './window-drag-region.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.window-drag-region--with-controls]': 'showWindowControls',
  },
})
export class WindowDragRegionComponent {
  private readonly platform = inject(PlatformService);

  protected readonly showWindowControls = this.platform.isWindowsElectron;
}
